import { AdaptableApi } from '@adaptabletools/adaptable/types';
import * as React from 'react';
import { fetchAllIssues, GetIssuesResponseType } from './api/issues';

const ISSUES_ASSIGNED_LATER = 5;
const ADD_ITEMS_INTERVAL = 5000;

export const useData = (
  adaptableApiRef: React.MutableRefObject<AdaptableApi | undefined>,
  repoPath: string
) => {
  const [issues, setIssues] = React.useState<GetIssuesResponseType>([]);

  React.useEffect(() => {
    if (!repoPath) {
      return;
    }

    const timeoutIds: any[] = [];

    (async () => {
      const [owner, repo] = repoPath.split('/');
      const issues = await fetchAllIssues(owner, repo, 1);

      const newIssues = issues.slice(0, ISSUES_ASSIGNED_LATER).reverse();
      const oldIssues = issues.slice(ISSUES_ASSIGNED_LATER);

      const addNewIssues = (index = 0, list: any[]) => {
        if (index > list.length - 1) {
          return;
        }
        adaptableApiRef.current!.gridApi.addGridData([list[index]]);
        const timeoutId = setTimeout(() => {
          addNewIssues(index + 1, list);
        }, ADD_ITEMS_INTERVAL);
        timeoutIds.push(timeoutId);
      };

      const timeoutId = setTimeout(
        () => addNewIssues(0, newIssues),
        ADD_ITEMS_INTERVAL
      );
      timeoutIds.push(timeoutId);
      setIssues(oldIssues);
    })();

    return () => timeoutIds.forEach((timeoutId) => clearTimeout(timeoutId));
  }, [repoPath, adaptableApiRef]);

  return issues;
};
